import { Icon, Tooltip } from '@mairistem/composants';
import { Feature, Menu } from '@mairistem/module';
import _ from 'lodash';

import { MENUS } from '@/constants';
import { showTooltips } from '@/utils';
import { useRegieStore, useRegisseurStore } from '@/zustand';
import { CyclesMenu } from '../Cycle';
import { FacturesMenu } from '../Facture';
import RecusMenu from '../RecusMenu/RecusMenu';

// Icône stable (hors rendu) : @mairistem/module ré-enregistre le menu, en fin de liste, dès que
// l'icône change de référence — ce qui arriverait à chaque re-rendu dû aux stores.
const ICON = showTooltips ? (
  <Tooltip
    trigger={<Icon name="list" />}
    message="Cycles, factures et reçus"
    position="right center"
  />
) : (
  <Icon name="list" />
);

const MenuListes = () => {
  const disabledMenus = useRegieStore((state) => state.disabledMenus);
  const regisseur = useRegisseurStore((state) => state.regisseur);

  return (
    <Menu
      code={MENUS.MENU_LISTES}
      name="Cycles, factures et reçus"
      icon={ICON}
      path="/listes"
      // @ts-expect-error
      visible={!_.isNil(regisseur) && !disabledMenus?.listes}
    >
      <Menu code={MENUS.MENU_LISTE_CYCLE} name="Cycles de facturation incorporés" path="/cycles">
        <Feature>
          <Feature.Content>
            <CyclesMenu />
          </Feature.Content>
        </Feature>
      </Menu>
      <Menu code={MENUS.MENU_LISTE_FACTURE} name="Factures" path="/factures">
        <Feature>
          <Feature.Content>
            <FacturesMenu />
          </Feature.Content>
        </Feature>
      </Menu>
      <Menu code={MENUS.MENU_LISTE_RECU} name="Reçus" path="/recus">
        <Feature>
          <Feature.Content>
            <RecusMenu />
          </Feature.Content>
        </Feature>
      </Menu>
    </Menu>
  );
};

export default MenuListes;
